import { useMutation } from '@tanstack/react-query';

import { deletePricingHistory, postPricingHistory, uploadPricingHistory } from './api';

export function usePricingHistoryMutation() {
    return useMutation(postPricingHistory);
}
export function useUploadPricingHistoryMutation() {
    return useMutation(uploadPricingHistory);
}
export function useDeletePricingHistoryMutation() {
    return useMutation(deletePricingHistory);
}
